import React, { FC, useCallback } from 'react';
import { dark } from 'react-syntax-highlighter/dist/cjs/styles/prism';
import { Redirect } from '@common/components/default/Redirect/Redirect';
import { trans } from '../../../modules/translation/translate';
import { Dropdown } from '../../dropdown/dropdown';
import { transProvablyFair } from '../../../pages/provablyFair.page/provablyFair.page';
import { SyntaxStyle } from './implementation.style';
import { IMPLEMENTATION_CONFIG } from './config';
import { GAMES_LIST } from './GAMES_LIST';

export const Implementation: FC<{
	game: string;
	setGame: (game: string) => void;
}> = ({ game, setGame }) => {
	const setGame_ = useCallback(
		(game) => setGame(game.toLowerCase()),
		[setGame],
	);
	const { code, description, implementation } = IMPLEMENTATION_CONFIG[game] || {
		code: null,
		description: null,
		implementation: null,
	};

	return (
		<>
			<Dropdown
				id={'provablyFairImplementationTab'}
				localTheme={{
					default: true,
				}}
				items={GAMES_LIST}
				active={game.toUpperCase()}
				onClick={setGame_}
			/>
			{!!description?.length && (
				<div className="box-no-height">
					{description.map((el, index) => {
						return (
							<p
								key={index}
								className="user-select-text margin-bottom text-style-sm-regular"
							>
								{transProvablyFair({ label: el })}
							</p>
						);
					})}
				</div>
			)}
			{implementation && (
				<div className="box-no-height user-select-text">
					<SyntaxStyle language="javascript" style={dark}>
						{implementation}
					</SyntaxStyle>
				</div>
			)}
			<div className="box-no-height">
				{code && (
					<p className="user-select-text margin-top text-style-sm-regular">
						{trans({ label: 'Example' })}:{' '}
						<Redirect
							target="_blank"
							rel="noreferrer noopener"
							href={`https://jsfiddle.net/suchijs/${code}/`}
						>
							https://jsfiddle.net/{game}Verify/
						</Redirect>
					</p>
				)}
				<p className="hint text-style-caption-regular">
					<span>
						{transProvablyFair({
							label: 'CryptoJS is a JavaScript package installed from',
						})}{' '}
					</span>
					<Redirect
						href="https://npmjs.com/package/crypto-js"
						className="text-underline"
						target="_blank"
						rel="noopener noreferrer"
					>
						npmjs.com/package/crypto-js
					</Redirect>
				</p>
			</div>
		</>
	);
};
